<ng-container *transloco="let t; prefix: 'image-editor-widget'">
    <div [style.height]="height" [style.width]="with" class="rounded-full overflow-hidden">
        <ng-template let-openFileSelector="openFileSelector" ngx-file-drop-content-tmp>
            <div class="p-2" fxFill fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">
                            <span class="text-center">{{ t("DragHere") }}</span>
                <button (click)="openFileSelector()" *ngIf="showPickOption" mat-stroked-button>
                                    {{ t("action.Select") }}
                </button>
            </div>
        </ng-template>

        <img *ngIf="hasImage" [src]="imageUrl" class="image-picture"/>
    </div>
</ng-container>